import { TwoFactorResponse, TwoFactorType, TwoFactorEnableResponse } from './../../entities/account/UserResponse';
import { map } from 'rxjs/operators';
import { UserResponse, AccountResponse, SignupRequest, LoginActivityResponse } from '@business/entities/account';
import { Endpoint, getGrandCentralAuth } from '../endpoint';
import { OAuthRequest, OAuthCheckResponse } from '@business/entities/oauth';
import { R } from '@core/utils/r';

export function loginForAccounts(email: string, password: string, remember = false) {
  const data = { email, password, keepalive: remember };

  return Endpoint.post<AccountResponse[]>('@gc/auth/accounts', { data });
}

export function verifyOTP(token: string, code: string, type: TwoFactorType) {
  return Endpoint.post<AccountResponse[]>('@gc/auth/verify-two-factor', { data: { token, code, type } });
}

export function loginWithTwoFactor(email: string, password: string, remember = false) {
  const data = { email, password, keepalive: remember };

  return Endpoint.post<TwoFactorEnableResponse>('@gc/auth/two-factor', { data });
}

export function resendCode(email: string, type: TwoFactorType) {
  const data = { email, type };

  return Endpoint.post<TwoFactorResponse>('@gc/auth/resend-two-factor', { data });
}

export function login(email: string, password: string, remember = false) {
  const data = { email, password, keepalive: remember };

  return Endpoint.post<UserResponse>('@gc/auth/login', { data });
}

export function switchAccount(email: string, appId: string) {
  const data = { email, appId };

  return Endpoint.post<UserResponse>('@gc/auth/switch', { data });
}

export function check(token: string) {
  return Endpoint.get<UserResponse>('@gc/auth/check', { auth: getGrandCentralAuth(token) }).pipe(map(user => ({ user })));
}

export function reset(email: string) {
  const data = { email };

  return Endpoint.post<void>('@gc/auth/reset', { data });
}

export function setEmail(email: string) {
  const data = { email };

  return Endpoint.post<void>('@gc/auth/set-email', { data });
}

export function setPassword(email: string, password: string, password_confirmation: string, token: string) {
  const data = { email, password, password_confirmation, token };

  return Endpoint.post<void>('@gc/auth/set-password', { data });
}

export function activate(password: string, password_confirmation: string, token: string) {
  const data = { password, password_confirmation, token };

  return Endpoint.post<void>('@gc/auth/activate', { data });
}

export function signUp(data: SignupRequest) {
  return Endpoint.post<UserResponse>('@gc/auth/signUp', { data });
}

export function controlAccount(appId: string, encodedToken?: string | null) {
  const data = R.objectCompact({ appId });

  return Endpoint.post<UserResponse>('@gc/auth/control', { data, params: R.objectCompact({ encodedToken }) });
}

export function controlAccountByEmail(appId: string, email: string, token: string | null, createToken:boolean|null) {
  const isCreateToken = createToken ??true;
  const data = R.objectCompact({ appId, email, token, isCreateToken });
  return Endpoint.post<UserResponse>('@gc/auth/control-by-email', { data });
}

/* OAuth */
export function authorizeCheck(data: OAuthRequest) {
  return Endpoint.post<OAuthCheckResponse>('@gc/auth/authorize-check', { data });
}

export function authorizeApprove(data: OAuthRequest) {
  return Endpoint.get<OAuthCheckResponse>('@gc/auth/authorize-approve', { params: data });
}

export interface LoginUrlResponse {
  url: string;
}
export function getLoginUrl(appId: string, email: string) {
  const data = { appId, email };

  return Endpoint.post<LoginUrlResponse>('@gc/auth/login-url', { data });
}
